import { Link } from "@nextui-org/link";
import { button as buttonStyles } from "@nextui-org/theme";

import { siteConfig } from "@/config/site";

export const ActionCall = () => {
  return (
    <div
      className="flex ct-hero w-full justify-center md:mx-auto"
      data-aos="fade-up"
    >
      <div className="md:container gap-4 pt-[80px]">
        <div className="lg:w-full xl:1/2 md:w-full flex sm:w-full justify-center items-center p-3 sm:p-2 mb-8 w-full">
          <div className="ctc-section flex flex-col justify-center items-center  md:mx-auto ct-section rounded-md">
            <div className="w-5/6 flex flex-col justify-center items-center">
              <h1 className="my-5 text-2xl font-bold ct-text-primary"> Get Started Today </h1>
              <h2 className="break-after-column md:w-4/6 my-2 text-lg lg:text-lg text-default-800 font-medium text-center p-5 mb-5">
                With CryptoTX, you're not just sending money; you're shaping the
                future of finance. Join us and experience the power of
                cryptocurrency in everyday transactions.
              </h2>
              <Link
                isExternal
                className={buttonStyles({
                  color: "primary",
                  radius: "md",
                  size: "lg",
                  variant: "shadow",
                })}
                href={siteConfig.links.register}>
                Get Started Now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
